<template>
 <VUEModalCaricamentoDati v-if="CaricamentoLingue" :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"/>
 
 <li :class="ClassMenuItem(MenuItem)" >
   <a @click="OnClickMenu(MenuItem)" style="padding: 7px;cursor: pointer;">
     <!-- <i :class="MainIcon" class="fa icon">
       <b v-if="MenuItem.Level == 1" :class="MenuItem.Data.ColorType"></b>
     </i> -->
     <span v-if="MenuItem.Level == 1 && MenuItem.Children.length > 0 || MenuItem.HasChildren" class="pull-right">
       <i :class="MenuItem.Expanded ? 'fa-angle-up' : 'fa-angle-down'" class="fa text"></i>
     </span>
     <span style="font-size: 13px">{{MenuItem.Caption}}</span>
   </a>
   <ul v-if="MenuItem.Expanded && MenuItem.Children.length > 0" class="nav" style="display: block;">
     <template v-for="SubMenuItem in MenuItem.Children" :key="SubMenuItem.Data.IdMenu">
        <VUESideMenuItem @onClickChiudiMenu="$emit('onClickChiudiMenu')" @onClickNascondiAllMenu="$emit('onClickNascondiAllMenu')" :MenuItem="SubMenuItem" :SideMenu="SideMenu"></VUESideMenuItem>
     </template> 
   </ul>
 </li>  
</template>

<script>

import { ID_PAGINE, SystemInformation, TIPOLOGIA_GRAFICI_STORICI, LOCALSTORAGE } from '@/SystemInformation';
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js'
import VUEModalCaricamentoDati from '@/utils/VUEModalCaricamentoDati.vue'

export default 
{
    name: "VUESideMenuItem",
    components: { VUEModalCaricamentoDati },
    props : ['MenuItem','SideMenu'],
    emits: ['onClickChiudiMenu', 'onClickNascondiAllMenu'],
    mixins: [ MixInsGestioneTraduzioni ],
    data() 
    {
        return {
                  MenuTrigger       : SystemInformation.MenuTrigger,
                  CaricamentoLingue : false,
                  LinguaUtente      : SystemInformation.UserInformation.Lingua
               };
    },
    methods:
    {
      OnClickMenu(AMenuItem)
      {
        var PercorsoDashboard = "/appMainWindow/Dashboard";
        var Parametri = TZGenericFunct.GetURLParameters();
        var OggettoInfoGraficiStoriciDaLocalStorage = localStorage.getItem(LOCALSTORAGE.OggettoInfoGraficiStorici);

        if('ChiaveSito' in Parametri)
          PercorsoDashboard += '?ChiaveSito=' + Parametri.ChiaveSito;
        else
        {
          if(OggettoInfoGraficiStoriciDaLocalStorage != null)
          {
            var JsonOggetto = JSON.parse(OggettoInfoGraficiStoriciDaLocalStorage);
            if(JsonOggetto.IdSito != null && JsonOggetto.IdSito != '')
              PercorsoDashboard += '?ChiaveSito=' + JsonOggetto.IdSito;
          }
        }

        this.SideMenu.Select(AMenuItem);
        this.SideMenu.ExpandToggle(AMenuItem);
        switch(AMenuItem.Data.IdMenu)
        {
          case ID_PAGINE.DASHBOARD                             : this.$emit('onClickChiudiMenu')
                                                                 this.$router.push(PercorsoDashboard);
                                                                 break;
          case ID_PAGINE.VERSIONE                              : this.$emit('onClickChiudiMenu')
                                                                 this.$router.push('/appMainWindow/VersioneDMSEW');
                                                                 break;
          case ID_PAGINE.AMM_GESTIONE_UTENTI                   : this.$emit('onClickChiudiMenu')
                                                                 this.$router.push('/appMainWindow/GestioneUtenti');
                                                                 break;
          case ID_PAGINE.AMM_GESTIONE_MESSAGGI                 : this.$emit('onClickChiudiMenu')
                                                                 this.$router.push('/appMainWindow/GestioneMessaggi');
                                                                 break;
          case ID_PAGINE.CFG_SITI                              : this.$emit('onClickChiudiMenu')
                                                                 this.$router.push('/appMainWindow/GestioneSiti')
                                                                 break;
          case ID_PAGINE.STORICI                               : this.$emit('onClickChiudiMenu')
                                                                 this.$router.push('/appMainWindow/GraficiStorici')
                                                                 break;
          case ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_A        : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A
                                                                 break;
          case ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_F        : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F
                                                                 break;
          case ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_SS       : SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SUP_SOGLIE
                                                                 this.RegisterFullPath()
                                                                 this.$emit('onClickChiudiMenu')
                                                                 this.$router.push('/appMainWindow/GraficiStorici')
                                                                 break;
          case ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_CE       : SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_CRONOLOGIA
                                                                 this.RegisterFullPath()
                                                                 this.$emit('onClickChiudiMenu')
                                                                 this.$router.push('/appMainWindow/GraficiStorici')
                                                                 break;
          case ID_PAGINE.POPUP_SPOSTAMENTO_GRAF_SEPARATI       : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI
                                                                 break;
          case ID_PAGINE.POPUP_SPOSTAMENTO_GRAF_SOVR           : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SOVR
                                                                 break;
          case ID_PAGINE.POPUP_VELOCITA_MEDIA_ORARIA           : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA
                                                                 break;
          case ID_PAGINE.POPUP_VELOCITA_MEDIA_GIORNALIERA      : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA
                                                                 break;
          case ID_PAGINE.POPUP_ACCELERAZIONE_MEDIA_ORARIA      : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA
                                                                 break;
          case ID_PAGINE.POPUP_ACCELERAZIONE_MEDIA_GIORNALIERA : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA
                                                                 break;
          case ID_PAGINE.POPUP_CAMPIONI_RILEVATI               : this.MenuTrigger.ApriPopupStorici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.CAMPIONI_RILEVATI
                                                                 break;
          case ID_PAGINE.POPUP_TENSIONE_ALIMENTAZIONE          : this.MenuTrigger.ApriPopupTensioneAssorbimento++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.TENSIONE_ALIMENTAZIONE
                                                                 break;
          case ID_PAGINE.POPUP_ASSORBIMENTO                    : this.MenuTrigger.ApriPopupTensioneAssorbimento++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.ASSORBIMENTO
                                                                 break;
          case ID_PAGINE.POPUP_STAZIONE_METEO                  : this.MenuTrigger.ApriPopupStazioneMeteo++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 SystemInformation.TipoPopupAperto = TIPOLOGIA_GRAFICI_STORICI.STAZIONE_METEO
                                                                 break;
          case ID_PAGINE.ESPORTAZIONE_XLSX                     : this.MenuTrigger.StampaXLSX++
                                                                 break;
          // case ID_PAGINE.RIASSUNTO_ACCELEROMETRI               : window.open('/appMainWindow/Sinottico', "_blank")
          //                                                        break;
          case ID_PAGINE.TORNA_ALLA_CATENA                     : if(SystemInformation.OggettoInfoGraficiStorici != null)
                                                                 {
                                                                  this.$emit('onClickChiudiMenu')
                                                                  this.$router.push(SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena)
                                                                 }
                                                                 break;
          case ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_X             : this.MenuTrigger.ApriPopupAllineamentoAsseX++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_INCLINOMETRI  : this.MenuTrigger.ApriPopupAllineamentoAsseInclinometri++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_PIEZOMETRI    : this.MenuTrigger.ApriPopupAllineamentoAssePiezometri++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_ESTENSIMETRI  : this.MenuTrigger.ApriPopupAllineamentoAsseDeformazioni++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_Y             : this.MenuTrigger.ApriPopupAllineamentoAsseY++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_TEMP          : this.MenuTrigger.ApriPopupAllineamentoAsseTemp++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.MODULAZIONE_GRAFICI                   : this.MenuTrigger.ApriPopupModulazioneGrafici++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;   
          case ID_PAGINE.MENU_ALLARMI                          : this.MenuTrigger.ApriPopupAllarmi++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;                                                      
          case ID_PAGINE.ADATTA_GRAFICI                        : this.MenuTrigger.TriggerAdattaGrafici++
                                                                 break;
          case ID_PAGINE.ESPORTA_PDF                           : this.MenuTrigger.TriggerEsportaPDF++
                                                                 break;
          case ID_PAGINE.SPOST_DIFFERENZIALE                   : this.MenuTrigger.TriggerDifferenziale++
                                                                 break;
          case ID_PAGINE.MEDIA_ARITMETICA                      : this.MenuTrigger.ApriPopupMediaAritmetica++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.CAMBIA_SCALE                          : this.MenuTrigger.ApriPopupCambiaScale++
                                                                 this.$emit('onClickNascondiAllMenu')
                                                                 break;
          case ID_PAGINE.MASSIMIZZA                            : this.MenuTrigger.TriggerMassimizza++
                                                                 break;
          case ID_PAGINE.AGGIORNA_LINGUE                       : this.$emit('onClickChiudiMenu')
                                                                 this.OnClickDownloadLingue()
                                                                 break;
          case ID_PAGINE.ESPORTA_XLSX_CAMPIONI_RILEVATI        : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.ApriPopupExportXLSXCampioniRilevati++
                                                                 break
          case ID_PAGINE.ESPORTA_XLSX_SPOSTAMENTI              : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.ApriPopupExportXLSXSpostamenti++
                                                                 break
          case ID_PAGINE.MOSTRA_NASCONDI_ALLARMI               : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.TriggerMostraNascondiAllarmi++
                                                                 break
          case ID_PAGINE.MOSTRA_SOGLIE_RILEVAMENTO             : this.MenuTrigger.TriggerMostraSoglieRilevamento++
                                                                 break
          case ID_PAGINE.NASCONDI_SOGLIE_RILEVAMENTO           : this.MenuTrigger.TriggerNascondiSoglieRilevamento++
                                                                 break
          case ID_PAGINE.MOSTRA_GRAFICI                        : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.TriggerMostraGrafici++
                                                                 break
          case ID_PAGINE.AGGIUNGI_ABBINATO                     : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.TriggerAggiungiAbbinato++
                                                                 break
          case ID_PAGINE.ALLINEA_POLARI                        : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.TriggerAllineaPolari++
                                                                 break
          case ID_PAGINE.MENU_CATENE                           : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.TriggerMenuCatene++
                                                                 break
          case ID_PAGINE.ABILITA_SPOSTAMENTO                   : this.$emit('onClickChiudiMenu')
                                                                 this.MenuTrigger.TriggerAbilitaSpostamento++
                                                                 break
          case ID_PAGINE.POPUP_IMPOSTA_ALLARMI                 : this.MenuTrigger.ApriPopupImpostaAllarmi++
                                                                 break
                                                                 
          case ID_PAGINE.POPUP_SCALA_X                         : this.MenuTrigger.ApriPopupScalaX++
                                                                 break
          case ID_PAGINE.POPUP_SCALA_Y                         : this.MenuTrigger.ApriPopupScalaY++
                                                                 break
          case ID_PAGINE.POPUP_SCALA_GRAPH_X                   : this.MenuTrigger.ApriPopupScalaGraphX++
                                                                 break
          case ID_PAGINE.POPUP_SCALA_GRAPH_Y                   : this.MenuTrigger.ApriPopupScalaGraphY++
                                                                 break
          case ID_PAGINE.POPUP_SCALA_GRAPH_Z                   : this.MenuTrigger.ApriPopupScalaGraphZ++
                                                                 break
          case ID_PAGINE.POPUP_COLORE_AMPIEZZA_ASSE_X          : this.MenuTrigger.ApriPopupColoreAmpiezzaX++
                                                                 break
          case ID_PAGINE.POPUP_COLORE_AMPIEZZA_ASSE_Y          : this.MenuTrigger.ApriPopupColoreAmpiezzaY++
                                                                 break
          case ID_PAGINE.POPUP_COLORE_AMPIEZZA_ASSE_Z          : this.MenuTrigger.ApriPopupColoreAmpiezzaZ++
                                                                 break
          case ID_PAGINE.POPUP_COLORE_FREQUENZA                : this.MenuTrigger.ApriPopupColoreFrequenza++
                                                                 break
          case ID_PAGINE.AGGIUNGI_RIGHELLO_ACCELEROMETRI       : this.MenuTrigger.ApriPopupAggiungiRighello++
                                                                 break
          case ID_PAGINE.ELIMINA_RIGHELLO_ACCELEROMETRI        : this.MenuTrigger.ApriPopupEliminaRighello++
                                                                 break
        }

      },

      OnClickDownloadLingue()
      {
        if(!this.CaricamentoLingue)
        {
          let Self = this
          this.CaricamentoLingue = true
          SystemInformation.AdvQuery.ExecuteExternalScript('CapricornGetTraduzioni', {},
                                                            function(Result)
                                                            {
                                                              if(Result != undefined)
                                                              {
                                                                alert(Self.GetTraduzioneLabel('VUESideMenuItem','TKN_SIDE_MENU_ITEM_ALERT_LINGUE_AGG',Self.LinguaUtente))
                                                              }
                                                              else SystemInformation.HandleError(Self.GetTraduzioneLabel('VUESideMenuItem','TKN_SIDE_MENU_ITEM_ERR_LINGUE_AGG',Self.LinguaUtente))
                                                              Self.CaricamentoLingue = false
                                                            },
                                                            function(HTTPError,SubHTTPError,Response)
                                                            {
                                                              Self.CaricamentoLingue = false
                                                              SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                            })    
        }
      },

      RegisterFullPath()
      {
        SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena = this.$route.fullPath
      },  

      ClassMenuItem(AMenuItem)
      {
        let Result = "";
        if(AMenuItem.Selected)
          Result += 'active ';
        Result += 'MenuColorLivello' + AMenuItem.Level;
        return Result.trim();
      },
    },

    computed :
    {
      MainIcon()
      {
        let Result = this.MenuItem.Data.IconCfg;
        if(this.MenuItem.Children.length > 0)
          if(this.MenuItem.Data.IconCfgExpanded != undefined)
             Result = this.MenuItem.Expanded ? this.MenuItem.Data.IconCfgExpanded : this.MenuItem.Data.IconCfgShrinked;
        return Result;
      },
    }
}

</script>
<style>
  .MenuColorLivello1 {
     background-color: rgb(241, 139, 83) !important ;
  }
  
  .MenuColorLivello2 {
     background-color: rgb(243, 153, 104) !important ;
  }
  
  .MenuColorLivello3 {
     background-color: rgb(244, 165, 123) !important ;
  }

  .blinking {
    animation: blinkingAnimation 2s infinite;
  }

  @keyframes blinkingAnimation {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }
  </style>

